/**
 *  logManageMentModule
 *
 * Description  管理配置 日志管理 系统日志
 * rebuild:SMG 2016-4-20
 */
"use strict";
angular.module('logManageMentSystemLogModule', [
	'logManageMentSystemLogRouterModule',
	'systemLogDebugModule',
    'systemlogPerformanceTestModule'
	])
.controller('logManageMentSystemLogCtrl', ['$scope',function($scope){

}]);
